import AppDispatcher from '../dispatcher/AppDispatcher';
import { parsePaymentHistoryResponse } from '../parsers/PaymentHistoryParser';

export const UPDATE_STATUS = 'UPDATE_STATUS';
export const UPDATE_TO_DATE = 'UPDATE_TO_DATE';
export const UPDATE_FROM_DATE = 'UPDATE_FROM_DATE';
export const UPDATE_DATE_INTERVAL = 'UPDATE_DATE_INTERVAL';
export const UPDATE_ACCOUNT = 'UPDATE_ACCOUNT';
export const UPDATE_FILTER_CRITERIA = 'UPDATE_FILTER_CRITERIA';
export const SET_PAYMENT_HISTORY_SME_ERROR = 'SET_PAYMENT_HISTORY_SME_ERROR';
export const SET_PAYMENT_HISTORY_SME_LIST = 'SET_PAYMENT_HISTORY_SME_LIST';
export const GET_SME_PAYMENT_HISTORY_LIST = 'GET_SME_PAYMENT_HISTORY_LIST';
export const SHOW_MORE_PAYMENT_HISTORY_SME = 'SHOW_MORE_PAYMENT_HISTORY_SME';
export const UPDATE_SORT_ORDER = 'UPDATE_SORT_ORDER';
export const UPDATE_SEARCH = 'UPDATE_SEARCH';
export const RESET_PAYMENT_HISTORY_SME = 'RESET_PAYMENT_HISTORY_SME';
export const SET_PAYMENT_HISTORY_CREATOR_LIST =
  'SET_PAYMENT_HISTORY_CREATOR_LIST';
export const SET_PAYMENT_HISTORY_CREATOR_ERROR =
  'SET_PAYMENT_HISTORY_CREATOR_ERROR';

const raise = (actionType, data) => {
  AppDispatcher.handleViewAction({
    actionType,
    data,
  });
};

export const getPaymentHistoryList = () => {
  raise(GET_SME_PAYMENT_HISTORY_LIST);
};
export const updateStatus = (status) => {
  raise(UPDATE_STATUS, status);
};
export const updateFromDate = (fromDate) => {
  raise(UPDATE_FROM_DATE, fromDate);
};
export const updateToDate = (toDate) => {
  raise(UPDATE_TO_DATE, toDate);
};
export const updateDateInterval = (dateInterval) => {
  raise(UPDATE_DATE_INTERVAL, dateInterval);
};
export const updateAccount = (accountId) => {
  raise(UPDATE_ACCOUNT, accountId);
};
export const updateFilterCriteria = (status) => {
  raise(UPDATE_FILTER_CRITERIA, status);
};
export const handlePaymentHistorySMESuccess = (response) => {
  const paymentHistoryList = parsePaymentHistoryResponse(response);
  raise(SET_PAYMENT_HISTORY_SME_LIST, paymentHistoryList);
};

export const handlePaymentHistorySuccessForCreator = (response) => {
  const paymentHistoryList = parsePaymentHistoryResponse(response);
  raise(SET_PAYMENT_HISTORY_CREATOR_LIST, paymentHistoryList);
};

export const handlePaymentHistorySMEFailure = (error, status) => {
  raise(SET_PAYMENT_HISTORY_SME_ERROR, { error, status });
};

export const handlePaymentHistoryFailureForCreator = (error, status) => {
  raise(SET_PAYMENT_HISTORY_CREATOR_ERROR, { error, status });
};

export const showMore = () => {
  raise(SHOW_MORE_PAYMENT_HISTORY_SME);
};

export const updateSortOrder = (sortBy, sortOrder) => {
  raise(UPDATE_SORT_ORDER, { sortBy, sortOrder });
};

export const resetPaymentHistory = () => {
  raise(RESET_PAYMENT_HISTORY_SME);
};

export const updateSearch = (search) => {
  raise(UPDATE_SEARCH, search);
};
